module.exports = __webpack_public_path__ + "img/商城中国联通语音卡.f5ec8ea2.png";